/// <reference path="../types/index.d.ts" />

import '../client_forms/tcamoreevent/style.css';
import FormStructure from './tcamoreevent/form_structure';

export default FormStructure;